import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import UnderConstructionView from "../views/UnderConstructionView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/construction",
    name: "construction",
    component: UnderConstructionView,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
